<script setup lang="ts">
const props = defineProps<{
	car: IProductModel
	minVal: number
	maxVal: number
	type: ESpecialDailyOfferType
	label?: EFormLabel
	timeframe: EContactFormRentalTimeframe
	discountPercentage?: number
}>()
const isElectricCar = props.car.parameters.find((p) => p.name === 'Fuel Type')?.value === 'Elektryczny'
const isModalOpen = defineModel<boolean>()
const i18nService = usei18nService()
</script>

<template>
	<GlobalModal v-model="isModalOpen" class="car-inquiry-modal">
		<div class="car-inquiry-modal__title">{{ $t('modules.long_term_page_module.car_inquiry_modal.inquiry') }}</div>
		<div class="car-inquiry-modal__container">
			<div class="car-inquiry-modal__details">
				<div class="car-inquiry-modal__image-wrap">
					<GlobalImage v-if="car?.image" class="car-inquiry-modal__image" :alt="car?.fullName" :src="car?.image" />
					<GlobalImage v-else class="car-inquiry-modal__image" alt="Car placeholder" src="car-placeholder.png" />
				</div>
				<p class="car-inquiry-modal__car-title">{{ car?.brand }} {{ car?.name }}</p>
				<div class="car-inquiry-modal__subtitle">
					<span
						>{{ $t('modules.long_term_page_module.car_inquiry_modal.or_similar') }}
						{{ i18nService.$tDynamic('pages.panel.discount_codes.code_id.segments', segmentsMapTranslations[car?.segment.name]) }}</span
					>
					<CarsSingleCarSegmentTooltip :segment="car.segment.name" :segmentID="car.segment.id" />
				</div>
				<!-- <div class="car-inquiry-modal__desc">
					<p>{{ $t('modules.long_term_page_module.car_inquiry_modal.car_model_description') }}</p>
					<p>
						{{ $t('modules.long_term_page_module.car_inquiry_modal.car_description') }}
					</p>
				</div> -->
				<div class="car-inquiry-modal__info-badges">
					<GlobalCarParameter
						v-for="(param, i) in filteredParametersByBags(car.parameters)"
						:key="i"
						:isElectric="isElectricCar"
						:parameter="param" />
				</div>
			</div>
			<CarInquiryModalForm
				:min-val="props.minVal"
				:max-val="props.maxVal"
				:car="car"
				:type="props.type"
				:label="props.label"
				:timeframe="props.timeframe"
				:discount-percentage="props.discountPercentage" />
		</div>
	</GlobalModal>
</template>

<style lang="scss">
@import './CarInquiryModal';
</style>
